import api from "./api";

export async function fetchQuizInstructions(params = {}) {
  const response = await api.get("/quiz/instructions", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
